import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import api from '../services/api';
import { Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

export default function MapaClientes({ clientes, onRecarregar }) {
  const [marcadores, setMarcadores] = useState([]);
  const [geocodificando, setGeocodificando] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!clientes || clientes.length === 0) return;
    setMarcadores(clientes.filter(c => c.lat && c.lon));
  }, [clientes]);

  const geocodificarTodos = async () => {
    setGeocodificando(true);
    const semCoordenadas = clientes.filter(c => !c.lat || !c.lon);
    let salvos = 0;
    for (const c of semCoordenadas) {
      try {
        const end = [c.logradouro, c.numero, c.cidade, c.estado, 'Brasil'].filter(Boolean).join(', ');
        const r = await api.get('/gestao/geocode', { params: { endereco: end } });
        if (r.data.lat && c.id) {
          // Buscar o id do cnpj
          await api.post('/gestao/geocode/salvar', { cnpj_id: c.cnpj_id || c.id, lat: r.data.lat, lon: r.data.lon });
          salvos++;
        }
        await new Promise(res => setTimeout(res, 300));
      } catch {}
    }
    message.success(`${salvos} clientes geocodificados!`);
    setGeocodificando(false);
    if (onRecarregar) onRecarregar();
  };

  const semCoordenadas = clientes.filter(c => !c.lat || !c.lon).length;

  return (
    <div>
      {semCoordenadas > 0 && (
        <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 6, padding: 8, marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{semCoordenadas} clientes sem coordenadas.</span>
          <Button size="small" onClick={geocodificarTodos} loading={geocodificando}>Geocodificar agora</Button>
        </div>
      )}
      <MapContainer center={[-19.9167, -43.9345]} zoom={6} style={{ height: 450, width: '100%', borderRadius: 8 }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {marcadores.map((m, i) => (
          <Marker key={i} position={[m.lat, m.lon]}>
            <Popup>
              <strong>{m.razao_filial || m.razao_social}</strong><br />
              {m.cnpj}<br />
              {m.cidade}/{m.estado}<br />
              {m.logradouro && <span>{m.logradouro}, {m.numero}<br /></span>}
              <Button size="small" onClick={() => navigate('/clientes/' + m.id)} style={{ marginTop: 4 }}>Ver cliente</Button>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
